import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import ZoomImage from "@/components/ZoomImage";

// Full-screen image viewer (scroll to zoom, drag to pan), portalled to <body> so it covers everything.
export default function ImageViewer({ src, onClose }) {
  useEffect(() => {
    if (!src) return undefined;
    const onKey = (e) => { if (e.key === "Escape") { e.stopPropagation(); e.preventDefault(); onClose(); } };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [src, onClose]);
  if (!src) return null;
  return createPortal(
    <div className="fixed inset-0 z-[200] bg-black/95 flex pointer-events-auto" data-testid="image-viewer" onPointerDown={(e) => e.stopPropagation()}>
      <div className="relative flex-1"><ZoomImage src={src} /></div>
      <button type="button" onClick={onClose} data-testid="image-viewer-close" className="absolute top-4 right-4 h-10 w-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"><X className="w-5 h-5" /></button>
      <span className="absolute top-5 right-16 text-[11px] font-mono text-zinc-400 pointer-events-none">Esc to close</span>
    </div>,
    document.body,
  );
}
